import { useState } from 'react';

import { useColorModeValue } from '@ecoinvent/ui';
import { FiChevronRight } from 'react-icons/fi';

import { COLORS, SUPPLY_CARD_TEXT_INDENT } from './constants';
import { stopEvents } from './utils';

const ViewDatasetButton = ({ onClick }: { onClick: () => void }) => {
  const [isHovered, setIsHovered] = useState(false);
  const color = useColorModeValue(COLORS.textLight, COLORS.textDark);

  return (
    <button
      type="button"
      className="nopan nodrag"
      style={{
        color,
        fontSize: '0.875rem',
        fontWeight: 600,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        background: 'none',
        border: 'none',
        fontFamily: 'inherit',
        padding: `0 0 0 ${SUPPLY_CARD_TEXT_INDENT}px`,
        textDecoration: isHovered ? 'underline' : 'none',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
      onPointerDown={stopEvents}
      onMouseDown={stopEvents}
      onClick={(e) => {
        stopEvents(e);
        onClick();
      }}
    >
      View detail <FiChevronRight size={14} />
    </button>
  );
};

export default ViewDatasetButton;
